import React, { Component } from "react";
import {
  Grid,
  Image,
  Form,
  Dropdown,
  Button,
  Search,
  Container
} from "semantic-ui-react";
import _ from "lodash";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import moment from "moment";
import { updateUser } from "../../modules/user/api";
import { APP_NAME } from "../../constants/resource.constants";
import { BASE_URL } from "../../constants/route.constants";
import { countries } from "../../data/countries.data";
import { positions } from "../../data/positions.data";
import ClubHistory from "../../components/ClubHistory/ClubHistory";
import { encodeClubUrl } from "../../helpers/clubHelper";
import { DEFAULT_PROFILE_IMG } from "../../constants/profile.constants";
import { CreateClubModel } from "../../models";
import FriendsList from "../../components/FriendsList/FriendsList";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/FooterView";

export default class AccountPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: { clubs: [] },
      selectedClub: {},
      selectedClubName: "",
      teams: [],
      startYear: "",
      endYear: "",
      isAddClubFormOpen: false,
      addClubErrors: {}
    };
  }

  componentDidMount() {
    this.setState({ user: this.props.user });
    this.handleChange = this.handleChange.bind(this);
    this.handleYearChange = this.handleYearChange.bind(this);
    this.handleTeamChange = this.handleTeamChange.bind(this);
    this.getDropdownYears = this.getDropdownYears.bind(this);
    this.addClub = this.addClub.bind(this);
    this.openAddClubForm = this.openAddClubForm.bind(this);
    this.closeAddClubForm = this.closeAddClubForm.bind(this);
    this.deleteClub = this.deleteClub.bind(this);
    this.getProfileImage = this.getProfileImage.bind(this);

    this.props.history.listen((location, action) => {
      window.scrollTo(0, 0);
    });
  }

  componentWillMount() {
    this.resetComponent();
  }

  componentWillUpdate(newProps) {
    if (this.props.user !== newProps.user) {
      this.setState({ user: newProps.user });
    }
  }

  resetComponent = () => {
    this.setState({
      isLoading: false,
      results: [],
      selectedClub: {},
      selectedClubName: "",
      teams: [],
      startYear: "",
      endYear: "",
      addClubErrors: {}
    });
  };

  getProfileImage() {
    return this.state.user.photo || DEFAULT_PROFILE_IMG;
  }

  handleResultSelect = (e, component) => {
    this.setState({
      selectedClub: component.result,
      selectedClubName: component.result.title
    });
  };

  handleSearchChange = (e, searchObj) => {
    const value = typeof searchObj === "object" ? searchObj.value : searchObj;
    var search = { query: { $sort: { name: 1 } } };
    if (!search.query["$or"]) {
      search.query["$or"] = [];
    }

    search.query["$or"].push({
      name: { $regex: value, $options: "i" }
    });
    search.query["$or"].push({
      city: { $regex: value, $options: "i" }
    });
    search.query["$or"].push({
      state: { $regex: value, $options: "i" }
    });
    search.query["$or"].push({
      country: { $regex: value, $options: "i" }
    });

    this.props.requestSearchClubs(search);

    this.setState({ isLoading: true, selectedClubName: value });

    setTimeout(() => {
      if (
        this.state.selectedClubName &&
        this.state.selectedClubName.length < 1
      ) {
        return this.resetComponent();
      }

      const source = _.map(this.props.clubs, club => {
        return {
          title: `${club.name} (${club.city})`,
          description: `${club.city} - ${club.state} - ${club.country}`,
          image: club.img || "/img/crest.svg",
          link: encodeClubUrl(club)
        };
      });

      this.setState({
        isLoading: false,
        results: source
      });
    }, 500);
  };

  handleChange(e, { name, value }) {
    const user = this.state.user;
    user[name] = value;

    updateUser(this.state.user._id, { [name]: value }).then(resp => {
      this.setState({ user: resp });
    });
  }

  handleYearChange(e, { name, value }) {
    this.setState({ [name]: value });
  }

  handleTeamChange(e, { name, value }) {
    const teams = this.state.teams;
    var index = teams.indexOf(value);

    if (index > -1) {
      teams.splice(index, 1);
    } else {
      teams.push(value);
    }

    this.setState({ teams });
  }

  // TODO: Move into utility method
  getDropdownYears(includePresent = false) {
    let currentYear = new Date().getFullYear(),
      years = [];
    const startYear = currentYear - 100;

    if (includePresent)
      years.push({ key: "present", value: "Present", text: "" });

    while (currentYear >= startYear) {
      const yearToAdd = currentYear--;
      years.push({ key: yearToAdd, value: yearToAdd, text: yearToAdd });
    }

    return years;
  }

  addClub() {
    const user = this.state.user;
    if (!user.clubs) user.clubs = [];

    const club = new CreateClubModel(this.state);
    const errors = club.validate();
    this.setState({ addClubErrors: errors });

    if (!_.isEmpty(errors)) {
      return;
    }

    user.clubs.push(club);

    updateUser(this.state.user._id, { clubs: user.clubs }).then(resp => {
      this.setState({ user: resp });
      this.setState({ isAddClubFormOpen: false });
    });

    this.resetComponent();
  }

  deleteClub(e, club) {
    e.stopPropagation();
    const clubs = _.without(this.state.user.clubs, club);

    updateUser(this.state.user._id, { clubs: clubs }).then(resp => {
      this.setState({ user: resp });
    });
  }

  openAddClubForm() {
    this.setState({ isAddClubFormOpen: true });
  }

  closeAddClubForm() {
    this.setState({ isAddClubFormOpen: false, addClubErrors: {} });
  }

  // TODO: Move form into component
  render() {
    const {
      isLoading,
      results,
      selectedClubName,
      startYear,
      endYear
    } = this.state;
    return (
      <div>
        <header>
          <NavBar {...this.props} />
        </header>
        <Container>
          <Helmet>
            <title>Account | {APP_NAME}</title>
            <meta
              name="description"
              content="Your GAA International account."
            />
            <link
              rel="canonical"
              href={`${BASE_URL}${window.location.pathname}`}
            />
            <meta property="og:title" content={`Account | ${APP_NAME}`} />
            <meta
              property="og:description"
              content="Your GAA International account."
            />
            <meta
              property="og:image"
              content="https://d3hfkx84ni8spj.cloudfront.net/misc/gaa-intl-lrg.png"
            />
            <meta
              property="og:url"
              content={`${BASE_URL}${window.location.pathname}/`}
            />
            <meta property="og:type" content="website" />
          </Helmet>
          <Grid columns={3} stackable={true}>
            <Grid.Column width={5}>
              <Image src={this.getProfileImage()} />
              <h4>General</h4>
              <span className="date">
                Joined in {moment(this.state.user.joined).format("YYYY")}
              </span>
              <h4>Friends</h4>
              {this.state.user.friends && this.state.user.friends.length > 0 ? (
                <FriendsList
                  friends={this.state.user.friends}
                  history={this.props.history}
                />
              ) : (
                <p>No friends yet :(</p>
              )}
            </Grid.Column>
            <Grid.Column width={8}>
              <h1>
                {this.state.user.firstName} {this.state.user.lastName}
              </h1>
              <Form>
                {/* <Form.Field
                control={Input}
                label="Username"
                className="inline-form-editing"
                onChange={this.handleChange}
                name="username"
                placeholder="Change username"
                value={this.state.user.username}
                fluid
              />*/}
                <Form.Field>
                  <label>Favorite Position</label>
                  <Dropdown
                    className="inline-form-editing"
                    placeholder="Select position"
                    search
                    selection
                    options={positions}
                    onChange={this.handleChange}
                    name="position"
                    value={this.state.user.position}
                    fluid
                  />
                </Form.Field>
                <Form.Field>
                  <label>Current Country</label>
                  <Dropdown
                    className="inline-form-editing"
                    placeholder="Select country"
                    search
                    selection
                    options={countries}
                    onChange={this.handleChange}
                    name="country"
                    value={this.state.user.country}
                    fluid
                  />
                </Form.Field>
                <h4>Clubs</h4>
                {this.state.user.clubs &&
                this.state.user.clubs.length > 0 &&
                !this.state.isAddClubFormOpen ? (
                  <ClubHistory
                    clubs={this.state.user.clubs}
                    openAddClubForm={this.openAddClubForm}
                    deleteClub={this.deleteClub}
                    history={this.props.history}
                  />
                ) : (
                  " "
                )}
                {this.state.isAddClubFormOpen ||
                !this.state.user.clubs ||
                !this.state.user.clubs.length ? (
                  <div className="add-club-form">
                    <Form.Field>
                      <Search
                        fluid
                        label="Name"
                        loading={isLoading}
                        onResultSelect={this.handleResultSelect}
                        onSearchChange={this.handleSearchChange}
                        results={results}
                        value={selectedClubName}
                        placeholder="Search or enter club"
                        className={
                          this.state.addClubErrors.club &&
                          this.state.addClubErrors.club.hasError
                            ? "error"
                            : " "
                        }
                      />
                      {this.state.addClubErrors.club &&
                      this.state.addClubErrors.club.hasError ? (
                        <p className="error">
                          {this.state.addClubErrors.club.message}
                        </p>
                      ) : (
                        " "
                      )}
                    </Form.Field>
                    <label>Teams</label>
                    <Form.Group inline>
                      <Form.Checkbox
                        label="Hurling"
                        name="hurling"
                        onChange={this.handleTeamChange}
                        value="Hurling"
                        error={
                          this.state.addClubErrors.teams &&
                          this.state.addClubErrors.teams.hasError
                        }
                      />
                      <Form.Checkbox
                        label="Camoige"
                        name="camoige"
                        onChange={this.handleTeamChange}
                        value="Camoige"
                        error={
                          this.state.addClubErrors.teams &&
                          this.state.addClubErrors.teams.hasError
                        }
                      />
                      <Form.Checkbox
                        label="Mens Football"
                        name="mensFootball"
                        onChange={this.handleTeamChange}
                        value="Mens Football"
                        error={
                          this.state.addClubErrors.teams &&
                          this.state.addClubErrors.teams.hasError
                        }
                      />
                      <Form.Checkbox
                        label="Ladies Football"
                        name="ladiesFootball"
                        onChange={this.handleTeamChange}
                        value="Ladies Football"
                        error={
                          this.state.addClubErrors.teams &&
                          this.state.addClubErrors.teams.hasError
                        }
                      />
                    </Form.Group>
                    {this.state.addClubErrors.teams &&
                    this.state.addClubErrors.teams.hasError ? (
                      <p className="error">
                        {this.state.addClubErrors.teams.message}
                      </p>
                    ) : (
                      " "
                    )}
                    <Form.Group widths="equal">
                      <Form.Select
                        search
                        fluid
                        label="Start year"
                        options={this.getDropdownYears(false)}
                        placeholder="Select year"
                        name="startYear"
                        value={startYear}
                        onChange={this.handleYearChange}
                        error={
                          this.state.addClubErrors.startYear &&
                          this.state.addClubErrors.startYear.hasError
                        }
                      />
                      <Form.Select
                        search
                        fluid
                        label="End year"
                        options={this.getDropdownYears(true)}
                        placeholder="Select year"
                        name="endYear"
                        value={endYear}
                        onChange={this.handleYearChange}
                      />
                    </Form.Group>
                    {this.state.addClubErrors.startYear &&
                    this.state.addClubErrors.startYear.hasError ? (
                      <p className="error">
                        {this.state.addClubErrors.startYear.message}
                      </p>
                    ) : (
                      " "
                    )}
                    <Button primary floated="right" onClick={this.addClub}>
                      Save club
                    </Button>
                    <Button
                      color="grey"
                      floated="right"
                      onClick={this.closeAddClubForm}
                    >
                      Close
                    </Button>
                  </div>
                ) : (
                  " "
                )}
              </Form>
            </Grid.Column>
            <Grid.Column width={3} />
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

AccountPage.defaultProps = {
  user: {},
  requestSearchClubs: () => ({})
};

AccountPage.propTypes = {
  requestSearchClubs: PropTypes.func,
  user: PropTypes.shape({
    _id: PropTypes.string,
    email: PropTypes.string
  }),
  requestLogout: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};



// WEBPACK FOOTER //
// ./src/routes/AccountsPage/View.js